import HardcoverLogo from "components/svgs/icons/HardcoverLogo";

const logos = {
  Default: {
    component: HardcoverLogo,
    className: "w-9",
  },
  Orange: { path: "HardcoverLogoOrange", className: "w-9" },
  GuyFawkes: {
    path: "HardcoverLogoGuyFawkes",
    className: "w-9 mr-2",
    startDate: "November 5",
    endDate: "November 5",
  },
  Thanksgiving: {
    path: "HardcoverLogoThanksgiving",
    className: "w-9 mr-2",
    startDate: "November 22",
    endDate: "November 24",
  },
  Christmas: {
    path: "HardcoverLogoChristmas",
    className: "w-10",
    startDate: "December 23",
    endDate: "December 27",
  },
  Valentines: {
    path: "HardcoverLogoValentines",
    className: "w-10",
    startDate: "February 13",
    endDate: "February 15",
  },
};

const LogoVariant = logos["Default"];

interface Props {
  className?: string;
}

export default function LogoSymbol({ className = "" }: Props) {
  const defaultClassName = LogoVariant.className || "";
  const combinedClassName = `${defaultClassName || "w-9"} ${className}`.trim();

  return <LogoVariant.component className={combinedClassName} />;
}
